import Card from "react-bootstrap/Card"
import Placeholder from "react-bootstrap/Placeholder"

export default function PlaceCardHolder() {
    return (
        <div className="d-flex justify-content-around">
            <Card className="card h-100" style={{ width: "100%" }}>
                <Card.Img
                    style={{ height: "10em", backgroundColor: "lightgray" }}
                    variant="top"
                />

                <Card.Body>
                    <Placeholder as={Card.Title} animation="glow">
                        <Placeholder xs={6} />
                    </Placeholder>
                    <Placeholder
                        as={Card.Text}
                        animation="glow"
                        className="text-start"
                    >
                        <Placeholder xs={7} /> <Placeholder xs={4} />{" "}
                        <Placeholder xs={4} /> <Placeholder xs={6} />{" "}
                        <Placeholder xs={8} />
                    </Placeholder>
                    <Placeholder.Button
                        variant="outline-secondary"
                        xs={2}
                        className="mt-3"
                    />
                </Card.Body>
            </Card>
        </div>
    )
}
